import { render, staticRenderFns } from "./ReviewCheck.vue?vue&type=template&id=339101a9&scoped=true"
import script from "./ReviewCheck.vue?vue&type=script&lang=js"
export * from "./ReviewCheck.vue?vue&type=script&lang=js"
import style0 from "./ReviewCheck.vue?vue&type=style&index=0&id=339101a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339101a9",
  null
  
)

export default component.exports